/**
 * Owner: Masa Bayu
 * File: script-registry.ts
 * Date:Time: 2026-09-20 00:59
 * Description: Canonical script registry — ISO 15924 · Batch 7 regional.
 */
const ENTRIES = Object.freeze([
    Object.freeze({
        scriptId: 'Latn',
        familyId: 'latin',
        defaultDirection: 'ltr',
        label: 'Latin',
        variants: Object.freeze([]),
    }),
    Object.freeze({
        scriptId: 'Arab',
        familyId: 'arabic',
        defaultDirection: 'rtl',
        label: 'Arabic',
        variants: Object.freeze([]),
    }),
    Object.freeze({
        scriptId: 'Hebr',
        familyId: 'hebrew',
        defaultDirection: 'rtl',
        label: 'Hebrew',
        variants: Object.freeze([]),
    }),
    Object.freeze({
        scriptId: 'Cyrl',
        familyId: 'cyrillic',
        defaultDirection: 'ltr',
        label: 'Cyrillic',
        variants: Object.freeze([]),
    }),
    Object.freeze({
        scriptId: 'Grek',
        familyId: 'greek',
        defaultDirection: 'ltr',
        label: 'Greek',
        variants: Object.freeze([]),
    }),
    Object.freeze({
        scriptId: 'Hans',
        familyId: 'cjk',
        defaultDirection: 'ltr',
        label: 'Han (Simplified)',
        variants: Object.freeze(['Hant']),
    }),
    Object.freeze({
        scriptId: 'Hant',
        familyId: 'cjk',
        defaultDirection: 'ltr',
        label: 'Han (Traditional)',
        variants: Object.freeze(['Hans']),
    }),
    Object.freeze({
        scriptId: 'Jpan',
        familyId: 'cjk',
        defaultDirection: 'ltr',
        label: 'Japanese',
        variants: Object.freeze([]),
    }),
    Object.freeze({
        scriptId: 'Kore',
        familyId: 'cjk',
        defaultDirection: 'ltr',
        label: 'Korean',
        variants: Object.freeze([]),
    }),
    Object.freeze({
        scriptId: 'Deva',
        familyId: 'indic',
        defaultDirection: 'ltr',
        label: 'Devanagari',
        variants: Object.freeze([]),
    }),
    Object.freeze({
        scriptId: 'Beng',
        familyId: 'indic',
        defaultDirection: 'ltr',
        label: 'Bengali',
        variants: Object.freeze([]),
    }),
    Object.freeze({
        scriptId: 'Guru',
        familyId: 'indic',
        defaultDirection: 'ltr',
        label: 'Gurmukhi',
        variants: Object.freeze([]),
    }),
    Object.freeze({
        scriptId: 'Gujr',
        familyId: 'indic',
        defaultDirection: 'ltr',
        label: 'Gujarati',
        variants: Object.freeze([]),
    }),
    Object.freeze({
        scriptId: 'Orya',
        familyId: 'indic',
        defaultDirection: 'ltr',
        label: 'Odia',
        variants: Object.freeze([]),
    }),
    Object.freeze({
        scriptId: 'Taml',
        familyId: 'indic',
        defaultDirection: 'ltr',
        label: 'Tamil',
        variants: Object.freeze([]),
    }),
    Object.freeze({
        scriptId: 'Telu',
        familyId: 'indic',
        defaultDirection: 'ltr',
        label: 'Telugu',
        variants: Object.freeze([]),
    }),
    Object.freeze({
        scriptId: 'Knda',
        familyId: 'indic',
        defaultDirection: 'ltr',
        label: 'Kannada',
        variants: Object.freeze([]),
    }),
    Object.freeze({
        scriptId: 'Mlym',
        familyId: 'indic',
        defaultDirection: 'ltr',
        label: 'Malayalam',
        variants: Object.freeze([]),
    }),
    Object.freeze({
        scriptId: 'Sinh',
        familyId: 'indic',
        defaultDirection: 'ltr',
        label: 'Sinhala',
        variants: Object.freeze([]),
    }),
    Object.freeze({
        scriptId: 'Thai',
        familyId: 'thai',
        defaultDirection: 'ltr',
        label: 'Thai',
        variants: Object.freeze([]),
    }),
    Object.freeze({
        scriptId: 'Laoo',
        familyId: 'lao',
        defaultDirection: 'ltr',
        label: 'Lao',
        variants: Object.freeze([]),
    }),
    Object.freeze({
        scriptId: 'Khmr',
        familyId: 'khmer',
        defaultDirection: 'ltr',
        label: 'Khmer',
        variants: Object.freeze([]),
    }),
    Object.freeze({
        scriptId: 'Mymr',
        familyId: 'myanmar',
        defaultDirection: 'ltr',
        label: 'Myanmar',
        variants: Object.freeze([]),
    }),
    Object.freeze({
        scriptId: 'Armn',
        familyId: 'armenian',
        defaultDirection: 'ltr',
        label: 'Armenian',
        variants: Object.freeze([]),
    }),
    Object.freeze({
        scriptId: 'Geor',
        familyId: 'georgian',
        defaultDirection: 'ltr',
        label: 'Georgian',
        variants: Object.freeze([]),
    }),
    Object.freeze({
        scriptId: 'Ethi',
        familyId: 'ethiopic',
        defaultDirection: 'ltr',
        label: 'Ethiopic',
        variants: Object.freeze([]),
    }),
    Object.freeze({
        scriptId: 'Tibt',
        familyId: 'tibetan',
        defaultDirection: 'ltr',
        label: 'Tibetan',
        variants: Object.freeze([]),
    }),
]);
const BY_ID = new Map(ENTRIES.map((entry) => [entry.scriptId, entry]));
export function listRegisteredScripts() {
    return ENTRIES;
}
export function getRegisteredScript(scriptId) {
    return BY_ID.get(scriptId);
}
export function isRegisteredScriptId(scriptId) {
    return BY_ID.has(scriptId);
}
//# sourceMappingURL=script-registry.js.map